<template>
  <div>
    <b-form-textarea v-model="codeComputed" rows="20"></b-form-textarea>
    <div class="d-flex justify-content-end">
      <small class="text-primary hover-pointer mt-1" @click="modalShown = true">
        Show Advanced Editor
      </small>
    </div>
    <b-modal
      modal-class="code-editor-modal"
      v-model="modalShown"
      title="Code Editor"
      centered
      size="xl"
      no-close-on-backdrop
      header-bg-variant="primary"
      header-text-variant="white"
      header-class="p-0 d-block shadow-form bg-purple"
      footer-class="bg-extra-light-gray shadow-form"
      hide-footer
      @shown="showCodeMirror = true"
      @hidden="showCodeMirror = false"
    >
      <template v-slot:modal-header>
        <div
          class="w-100 d-flex flex-row justify-content-between align-items-center"
          style="padding: 13px 20px;"
        >
          <div>
            <h5 class="modal-title font-weight-bold">Code Editor</h5>
          </div>
          <button
            type="button"
            aria-label="Close"
            class="close text-white"
            style="opacity:1 !important"
            @click="closeModal"
          >
            ×
          </button>
        </div>
      </template>
      <template v-slot:modal-footer>
        <div
          class="d-flex flex-row justify-content-end align-items-center w-100"
        >
          <div class="mt-1">
            <b-button @click="closeModal" variant="secondary">Close</b-button>
          </div>
        </div>
      </template>
      <div class="h-100">
        <codemirror
          v-if="showCodeMirror"
          v-model="codeComputed"
          :options="cmOptions"
        ></codemirror>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FormBuilderCodeEditor",
  props: ["value"],
  data() {
    return {
      modalShown: false,
      showCodeMirror: false,
      cmOptions: {
        tabSize: 4,
        mode: {
          name: "javascript",
          json: true
        },
        theme: "base16-dark",
        lineNumbers: true,
        line: true
      },
      code: "const a = 10"
    };
  },
  methods: {
    closeModal() {
      this.modalShown = false;
    }
  },
  computed: {
    ...mapGetters("layout", ["isTechStaff"]),
    codeComputed: {
      get() {
        return this.value;
      },
      set(newValue) {
        if (!this.isTechStaff) {
          newValue = newValue.replace("{{","").replace("}}","");
        }
        this.$emit("input", newValue);
      }
    }
  }
};
</script>
<style>
.code-editor-modal .shadow-footer-sm {
  box-shadow: 0px -8px 5px -7px rgb(0 0 0 / 8%);
}
.shadow-form {
  box-shadow: 0px 0px 14px -2px rgba(0, 0, 0, 0.5);
}
.code-editor-modal .modal-body {
  height: 85vh;
  overflow-y: auto;
}
.code-editor-modal .CodeMirror {
  height: 82vh !important;
}
</style>
